export const RETAILER_LIST_VIEW_MODE_OPTIONS = [
  { text: 'Active', value: 'active', label: 'Active', name: 'active' },
  { text: 'Deleted', value: 'deleted', label: 'Deleted', name: 'deleted' },
];

export const RETAILER_LIST_VIEW_MODE_IN_BUSINESS = { active: 't' };
export const RETAILER_LIST_VIEW_MODE_VALUE = { deleted: 't' };

export const ACTION_BUTTON_TEXT_OPTIONS = { active: 'Delete retailer', deleted: 'Restore retailer' };
